let instance = null;

class Store {
	constructor() {
		if (!instance) {
			instance = this;
		}

		this.state();

		return instance;
	}

	state() {
		this.isSiteMobileNavOpen = false;
	}
}

export default new Store();
